module.exports = __webpack_public_path__ + "img/flag-canada.a7e43c6.svg";